import { Form } from 'antd'
import styled from 'styled-components'

export const FormAuth = styled(Form)`
  .ant-form-item-label > label {
    color: #fff;
  }
  .ant-checkbox + span {
    color: #fff;
  }

  .ant-btn-primary {
    background: #15b999;
    border-color: #15b999;
    width: 160px;
  }
  .ant-checkbox-checked .ant-checkbox-inner {
    background-color: #15b999;
    border-color: #15b999;
  }

  .ant-btn-link {
    color: #15b999;
  }
  input:focus,
  input[type]:focus,
  .uneditable-input:focus {
    border-color: #15b999;
    outline: 0 none;
  }

  input {
    background-color: #fff;
    color: #000;
    width: 280px;
  }

  .ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover {
    border-color: #15b999;
    background-color: #fff;
  }

  .ant-input-password-icon {
    color: #000;
  }

  .ant-input-affix-wrapper-sm {
    background-color: #fff;
  }

  span.ant-input-affix-wrapper.ant-input-affix-wrapper-sm.ant-input-password.ant-input-password-small,
  input#login-input-CPF {
    width: 320px;
  }
  .ant-card-body > .ant-row {
    height: 455px;
  }
`
